import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v1/asset-tag';

export class AssetTagService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}
  async patchAssetTag(params: types.PatchAssetTagParameters): Promise<types.PatchAssetTagResponse> {
    const { data } = await this.axios.patch<types.PatchAssetTagResponse>(
      `/v1/asset-tags/${params.path.assetTagId}`,
      params.body,
    );
    return data;
  }

  async deleteAssetTag(params: types.DeleteAssetTagParameters): Promise<void> {
    await this.axios.delete<void>(`/v1/asset-tags/${params.path.assetTagId}`);
  }
}
